﻿export const Language = Object.freeze({
    English: 1,
    French: 2,
    Spanish: 3
});

export const LanguageName = Object.freeze({
    EN: 'en',
    FR: 'fr',
    ES: 'es'
});